import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";
import pattern1 from "../../img/pattern/pattern-1-1236.png";

export const gameHeaderContainerStyles = style({
  position: "relative",
  isolation: "isolate",
  backgroundImage: `linear-gradient(90deg, ${vars.colors.plBlue} 0%, ${vars.colors.plLilac} 100%)`,
  selectors: {
    '[dir="rtl"] &': {
      backgroundImage: `linear-gradient(270deg, ${vars.colors.plBlue} 0%, ${vars.colors.plLilac} 100%)`,
    },
    "&::before": {
      position: "absolute",
      zIndex: -1,
      inset: "0",
      background: `url(${pattern1}) right top -197px / 204px 315px no-repeat`,
      content: '""',
    },
    '[dir="rtl"] &::before': {
      transform: "scaleX(-1)",
    },
  },
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      selectors: {
        "&::before": {
          background: `url(${pattern1}) right top -269px / 356px 441px no-repeat`,
        },
      },
    },
  },
});

export const gameHeaderStyles = style({
  display: "flex",
  justifyContent: "space-between",
  margin: "0 auto",
  padding: `0 ${vars.space.m}`,
  maxWidth: breakpoints[7],
});

export const gameHeaderLogoStyles = style({
  display: "block",
  height: 38,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      height: 58,
    },
  },
});

export const playerLockupStyles = style({
  display: "none",
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      display: "block",
      marginTop: vars.space.xs,
      paddingInlineEnd: vars.space["5xl"],
      height: 138,
    },
  },
});

export const gameTabContainer = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  gap: vars.space.s,
  paddingTop: vars.space.s,

  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      gap: vars.space.l,
      paddingTop: vars.space.m,
    },
  },
});
